import AddIcon from "@mui/icons-material/Add";
import { Box, Paper, Typography, useTheme } from "@mui/material";
import * as React from "react";
import { Link } from "react-router";

import styles from "./DashboardButton.module.css";

interface DashboardButtonProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  bgColor: string;
  iconColor: string;
  href: string;
}

export const DashboardButton: React.FC<DashboardButtonProps> = ({
  title,
  description,
  icon,
  bgColor,
  iconColor,
  href,
}) => {
  const theme = useTheme();
  return (
    <Link className={styles.noDecoration} to={href}>
      <Box
        bgcolor={theme.palette.paper.main}
        className={styles.buttonContainer}
        component={Paper}
        variant="outlined"
        sx={{
          "&:hover": {
            // This is a shorthand syntax used by MUI
            boxShadow: 1,
          },
        }}
      >
        <div className={styles.descriptionContainer}>
          <Box
            bgcolor={bgColor}
            borderRadius={theme.border.radius}
            className={styles.actionIcon}
            color={iconColor}
          >
            {icon}
          </Box>
          <div>
            <Typography color={theme.palette.text.primary} variant="body1">
              <strong>{title}</strong>
            </Typography>
            <Typography
              color={theme.palette.text.secondary}
              fontSize={"0.8rem"}
              variant="body2"
            >
              {description}
            </Typography>
          </div>
        </div>
        <div className={styles.flexCenter}>
          <AddIcon />
        </div>
      </Box>
    </Link>
  );
};
